import { IconWrapper } from '../runtime';
export default IconWrapper('ksheet-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '40b2cea5' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.1875 7.875H17.25V10.875H12.1875V7.875ZM9.9375 7.875H6.75V10.875H9.9375V7.875ZM6.75 13.125V16.125H9.9375V13.125H6.75ZM12.1875 16.125H17.25V13.125H12.1875V16.125ZM5.625 18.375C5.00368 18.375 4.5 17.8713 4.5 17.25L4.5 6.75C4.5 6.12868 5.00368 5.625 5.625 5.625H18.375C18.9963 5.625 19.5 6.12868 19.5 6.75V17.25C19.5 17.8713 18.9963 18.375 18.375 18.375H5.625Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '40b2cea5',
      "x1": "7.51152e-08",
      "y1": "1.82812",
      "x2": "21.7969",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#2DE057"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#16A353"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#00AA4A"
    }
  })])])]);
});